import styled from 'styled-components';
import { motion } from 'framer-motion';

export const MotionRouteContainer = styled(motion.div)``;
